import { render, staticRenderFns } from "./LoginV2.vue?vue&type=template&id=0ec3bc8f&scoped=true&"
import script from "./LoginV2.vue?vue&type=script&lang=js&"
export * from "./LoginV2.vue?vue&type=script&lang=js&"
import style0 from "./LoginV2.vue?vue&type=style&index=0&id=0ec3bc8f&lang=scss&scoped=true&"
import style1 from "./LoginV2.vue?vue&type=style&index=1&id=0ec3bc8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec3bc8f",
  null
  
)

export default component.exports